import { atom } from 'jotai'

const isAuthenticatedAtom = atom<boolean>(false)
const chooseImitatorAtom = atom<boolean>(false)
const authRoles = atom<string[]>([])
const canAccessLoenindplaceringer = atom<boolean>(false)

export {
    isAuthenticatedAtom,
    chooseImitatorAtom,
    authRoles,
    canAccessLoenindplaceringer,
}
